import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Card, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { create, updateAction } from "../../../store/actions/CommonActions";
import ArtistForm from "../Forms/ArtistForm";
import { apiCaller } from "../../../services/AxiosInstance";
import { toast } from "react-toastify";
import { getImageUrl } from "../../pages/Artist/ArtistAvatar";
import { getAgeFromDob } from "../../../utils/functions/date";

const AddExistingArtist = ({ modalConfig }) => {
    // const closeModal = setShow(false);
    const { closeModal, projectId, showModal, onAdd } = modalConfig;
    const [search, setSearch] = useState("");
    const [searching, setSearching] = useState(true);
    const [artistList, setArtistList] = useState([]);
    useEffect(() => {
        const delayDebounce = setTimeout(async () => {
            try {
                if (search.length >= 3) {
                    setSearching(true);
                    const response = await apiCaller({ method: "get", url: `artist/search-artist-by-number?search=${search}&project=${projectId}` });
                    if (response?.data?.success) {
                        setArtistList(response?.data?.data);
                    } else {
                        setArtistList([]);
                    }
                    setSearching(false);
                } else {
                    setArtistList([]);
                }
            } catch (error) {
                setSearching(false);
                console.log(error);
            }
        }, 500);
        return () => clearTimeout(delayDebounce);
    }, [search]);

    const addArtistToProject = async (artist) => {
        onAdd(artist);
        // 🔍 upload file to server and return the uploaded file url
        // try {
        //     const responseData = await apiCaller({
        //         method: "post",
        //         url: "/artist/add-artist-to-project",
        //         params: null,
        //         data: {
        //             artistId: artistId,
        //             projectId: projectId
        //         },
        //     });
        //     if (responseData?.data?.success) {
        //         setSearch("");
        //         if (closeModal) closeModal();
        //     }
        //     // setSubmitting(false);
        // } catch (err) {
        //     console.error(err);
        //     // alert("Error uploading file");
        // }
    }

    const searchArtist = (e) => {
        if (e.target.value == "") setSearch("");
        let val = e.target.value?.trim();
        // const regex = /^[0-9]+$/;
        // if (regex.test(e.target.value)) {
        setSearch(val);
        // }
    }
    return (
        <Card
            className="pb-3"
            id="AddExistingArtist"
            style={{ height: "auto", minHeight: '535px' }}
            show={showModal ?? true}
            onHide={(e) => closeModal(e) ?? null}
        >
            <Modal.Header>
                <Modal.Title>
                    Add Existing Artist
                </Modal.Title>
                {closeModal ? (
                    <button
                        type="button"
                        className="btn-close"
                        data-dismiss="modal"
                        onClick={closeModal}
                    ></button>
                ) : null}
            </Modal.Header>
            <div className="d-flex justify-content-between align-items-center px-4">
                <div class="input-group w-100 search-area d-xl-inline-flex d-none">
                    <button class="input-group-text">
                        <i class="flaticon-381-search-2 text-primary"></i>
                    </button>
                    <input
                        onChange={searchArtist}
                        value={search}
                        type="text"
                        class="form-control"
                        placeholder="Search using Artist's Name or Mobile Number..."
                    />
                </div>
            </div>
            <hr />
            {artistList?.map((artistDetails) => (
                <div className="d-flex justify-content-between align-items-center px-4">
                    <div className="main-title d-flex align-items-center justify-content-between w-100">
                        {/* Avatar */}
                        <div className="d-flex align-items-start gap-2">
                            <div
                                className="rounded-circle border d-flex align-items-center justify-content-center me-3"
                                style={{ width: "40px", height: "40px" }}
                            >
                                <img src={getImageUrl(artistDetails?.profile_image)} style={{ width: "40px", height: "40px", borderRadius: "50%" }} />
                            </div>
                            <div className="me-4">
                                <div className="d-flex align-items-center gap-2">
                                    <h4 className="m-0">{`${artistDetails?.firstName} ${artistDetails?.lastName}`}</h4>
                                    <div className="d-flex gap-2 align-items-center" style={{
                                        border: "1px solid black",
                                        borderRadius: "4.3px",
                                        padding: "3px 4.5px",
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                        textTransform: "uppercase"
                                    }}>
                                        <span className="success-icon fs-14">Showcased</span>
                                        <span className="badge bg-success">
                                            {artistDetails?.projects?.filter((p) => p.status === "Showcase").length ??
                                                0}
                                        </span>
                                    </div>
                                    <div className="d-flex gap-2 align-items-center" style={{
                                        border: "1px solid black",
                                        borderRadius: "4.3px",
                                        padding: "3px 4.5px",
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                        textTransform: "uppercase"
                                    }}>
                                        <span className="">Projects</span>
                                        <span className="badge bg-dark">{artistDetails?.projects?.length ?? 0}</span>
                                    </div>
                                </div>
                                <p>
                                    {getAgeFromDob(artistDetails?.dob)} {`${artistDetails?.gender ? `| ${artistDetails?.gender}` : ""}`} {`${artistDetails?.city?.name ? `| ${artistDetails?.city?.name}` : ""}`}
                                </p>
                            </div>
                        </div>
                    </div>
                    <button className="btn btn-primary" onClick={() => {
                        addArtistToProject(artistDetails);
                    }}>
                        Add
                    </button>
                </div>
            ))}
            {search == "" || search.length < 3 ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
                    <span className="text-muted">Result will appear here</span>
                </div>
            ) : null}
            {search != "" && search.length >= 3 && artistList?.length == 0 ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
                    <span className="text-muted">{searching ? 'Searching...' : 'No artist found'}</span>
                </div>
            ) : null}
        </Card>
    );
};

export default AddExistingArtist;
